import {Box, Button, Stack, Typography, useTheme} from "@mui/material";
import {PersonaTheme} from "../../common/enums/personaTheme.enum";
import React, {useEffect, useState} from "react";
import celestialProfilePreview from "../../common/images/previews/celestial_preview_image.webp";
import bratProfilePreview from "../../common/images/previews/brat_preview_image.webp";
import retroY2KProfilePreview from "../../common/images/previews/retro_y2k_preview_image.webp";

interface ThemePreviewProps {
    userTheme: PersonaTheme;
    setUserTheme: (arg1: any) => void;
    isNewProfile?: boolean;
}

//todo use radio buttons so that it can be hooked into the form using value instead of passing state setter
export const ThemePreviewInput = ({userTheme, setUserTheme, isNewProfile}:ThemePreviewProps)  => {
    
    const theme = useTheme();
    const [previewImage, setPreviewImage] = useState<string>(celestialProfilePreview);

    useEffect(() => {
        switch (userTheme){
            case PersonaTheme.Brat:
                setPreviewImage(bratProfilePreview);
                break;
            case PersonaTheme.Celestial:
                setPreviewImage(celestialProfilePreview);
                break;
            case PersonaTheme.RetroY2K:
                setPreviewImage(retroY2KProfilePreview);
                break;
            default:
                setPreviewImage("");
                break;
        }

    }, [userTheme]);

    return (
        <Stack paddingX={2.5} alignSelf={"center"} flexDirection={"column"} marginBottom={theme.spacing(2)}
               width={"100%"} maxWidth={{xs: '100%', sm: 550}} gap={2} >
            <Stack maxWidth={{xs: '100%', sm: 550}} flexDirection={"row"} >
            <Typography
                variant="subtitle1"
                fontWeight={"bold"}
                color={theme.palette.thatsMe.textTitle}
            >
                {isNewProfile ? 'Select a theme' : 'Change theme'}
            </Typography>
            </Stack>
            <Stack marginTop={theme.spacing(2)} maxWidth={{xs: '100%', sm: 550}} flexDirection={"row"} gap={2}>
            <Button
                variant={"themeSelectCelestial"}
                sx={{opacity: userTheme == PersonaTheme.Celestial ? "100%" : "50%", minWidth: 60, flex: 1}}
                onClick={() => setUserTheme(PersonaTheme.Celestial)} >Celestial</Button>
            <Button 
                variant={"themeSelectRetroY2K"}
                sx={{opacity: userTheme == PersonaTheme.RetroY2K ? "100%" : "50%", minWidth: 60, flex: 1}}
                onClick={() => setUserTheme(PersonaTheme.RetroY2K)} >Retro Y2K</Button>
            <Button
                variant={"themeSelectBrat"}
                sx={{opacity: userTheme == PersonaTheme.Brat ? "100%" : "50%", minWidth: 60, flex: 1}}
                onClick={() => setUserTheme(PersonaTheme.Brat)} >
                <Typography sx={{filter: "blur:0.5", transform: "scale(1,1.3)", fontFamily: "arial"}}>brat</Typography>
            </Button>
            </Stack>
            <Box
                justifyContent={"center"}
                display={"flex"}
                height={"auto"}
                marginTop={4}
            >
                <img src={previewImage} alt={"profile preview"} height={350}/>
            </Box>
        </Stack>
    );
}